export const PRICING_API = "https://api.coingecko.com/api/v3/simple/price";
export const networks = [
  {
    id: "ethereum",
    name: "Ethereum",
    icon: "🔷",
    description: "The original smart contract platform",
  },
  {
    id: "bnb",
    name: "BNB Smart Chain",
    icon: "🟡",
    description: "Binance Smart Chain",
  },
  {
    id: "opbnb",
    name: "opBNB",
    icon: "⚫",
    description: "Optimistic BNB Chain",
  },
  {
    id: "arbitrum",
    name: "Arbitrum One",
    icon: "🔵",
    description: "Layer 2 scaling solution",
  },
  {
    id: "base",
    name: "Base",
    icon: "🔵",
    description: "Coinbase L2 network",
  },
  {
    id: "tron",
    name: "Tron",
    icon: "🔴",
    description: "High-performance blockchain",
  },
  {
    id: "solana",
    name: "Solana",
    icon: "⚫",
    description: "Fast blockchain platform",
  },
  {
    id: "polygon",
    name: "Polygon",
    icon: "🟣",
    description: "Ethereum scaling solution",
  },
  {
    id: "avalanche",
    name: "Avalanche",
    icon: "🔴",
    description: "Fast and secure blockchain",
  },
  {
    id: "blast",
    name: "Blast",
    icon: "🟡",
    description: "Blast network",
  },
];

export const SourceNetworks = [
  {
    id: "base",
    name: "Base",
    iconUrl: "/baseIcon.svg",
  },
  // {
  //   id: "ethereum",
  //   name: "Ethereum",
  //   iconUrl: "/eth.svg",
  // },
];

export const tokens = [
  {
    id: "anlog",
    name: "ANLOG",
    iconUrl: "./assets/images/clock.svg",
    balance: "25,000",
  },
  // {
  //   id: "eth",
  //   name: "Ethereum",
  //   iconUrl: "/assets/tokens/eth.png",
  //   balance: "5.438",
  // },
  // {
  //   id: "usdc",
  //   name: "USDC",
  //   iconUrl: "/assets/tokens/usdc.png",
  //   balance: "1,230.12",
  // },
];
